import React from "react";
import calloutCardThemes from "@streeteasy/design-system/callout-card/constants/calloutCardThemes";
import { HorizontalCalloutCardLink } from "@streeteasy/design-system/callout-card/HorizontalCalloutCard";
import { number } from "prop-types";

import { dispatchAccessFromHDPEvent } from "../../utilities/gaTracking";
import * as S from "./styled";
import VectorIcon from "./VectorIcon";

const SellerDashboardEntrypoint = ({ saleId }) => (
  <S.CardWrapper>
    <HorizontalCalloutCardLink
      callToActionCopy={
        <span>
          <VectorIcon />
          SEE PERFORMANCE
        </span>
      }
      description="Track your total activity from StreetEasy visitors. Plus, see how it compares to similar homes that have sold recently."
      headline="See how your listing is performing"
      href={`/seller_dashboard/${saleId}`}
      onClick={dispatchAccessFromHDPEvent}
      target="_blank"
      theme={calloutCardThemes.ORANGE}
    />
  </S.CardWrapper>
);

SellerDashboardEntrypoint.propTypes = {
  saleId: number.isRequired
};

export default SellerDashboardEntrypoint;
